import { useQueryClient } from 'react-query';

import {
  MERCURE_MESSAGE_TYPE_NOTIFICATION,
  useMercureContext,
} from '@/common/contexts/MercureContext/MercureContext';
import useMercureMessageSubscriber from '@/common/contexts/MercureContext/useMercureMessageSubscriber';

const useNotificationsSubscription = (queryKey) => {
  const { customerTopic } = useMercureContext();
  const queryClient = useQueryClient();

  const handleSubscribe = (data) => {
    if (data?.payload?.data?.[0]) {
      queryClient.invalidateQueries(queryKey);
    }
  };

  useMercureMessageSubscriber(
    customerTopic,
    MERCURE_MESSAGE_TYPE_NOTIFICATION,
    handleSubscribe,
  );
};

export default useNotificationsSubscription;
